import { useCallback } from "react";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

const useExcelDownload = () => {
    const downloadExcel = useCallback((flatData, fileName = "Fleet Report") => {
        if (!flatData || !Array.isArray(flatData) || flatData.length === 0) {
            console.warn("No flatData provided to download Excel.");
            return;
        }

        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";

        const worksheet = XLSX.utils.json_to_sheet(flatData);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(blob, `${fileName}${fileExtension}`);
    }, []);

    return downloadExcel;
};

export const useCsvBlob = () => {
    const getCsvBlob = useCallback((flatData, fileName = "Fleet Report") => {
        if (!flatData || !Array.isArray(flatData) || flatData.length === 0) {
            console.warn("No flatData provided to generate CSV.");
            return null;
        }

        // 1. Convert JSON to worksheet
        const worksheet = XLSX.utils.json_to_sheet(flatData);

        // 2. Convert worksheet to CSV
        const csv = XLSX.utils.sheet_to_csv(worksheet);

        // 3. Create Blob from CSV
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

        // 4. Optional: return both blob and file name
        return {
            blob,
            file: new File([blob], `${fileName}.csv`, { type: "text/csv" }),
        };
    }, []);

    return getCsvBlob;
};


export default useExcelDownload;